const checkingOverflowBodyForModals = (state) => {
    if (state) {
        if (!document.body.classList.contains('body_disableOverflow')) document.body.classList.add('body_disableOverflow')
    } else document.body.classList.remove('body_disableOverflow')
}

export default checkingOverflowBodyForModals;